import React from 'react';
import './App.css';
import Header from './components/Header';
import './components/Header.css';
import Hero from './components/Hero';
import './components/Hero.css';
import AboutMe from './components/AboutMe';
import './components/AboutMe.css';
import Skills from './components/Skills';
import './components/Skills.css';
import Projects from './components/Projects';
import './components/Projects.css';
import Contact from './components/Contact';
import './components/Contact.css';

function App() {
  return (
    <div className="App">
      <Header />
      <section id="home">
        <Hero />
      </section>
      <section id="about">
        <AboutMe />
      </section>
      <section id="skills">
        <Skills />
      </section>
      <section id="projects">
        <Projects />
      </section>
      <section id="contact">
        <Contact />
      </section>
    </div>
  );
}

export default App;